const LOCALE = "en-US";
const TIME_FORMAT = { hour: "numeric", minute: "2-digit" };

export const formatClockTime = (timestampMs) =>
  new Date(timestampMs).toLocaleTimeString(LOCALE, TIME_FORMAT);
